export default __webpack_public_path__ + "static/media/Picador_Fela_Bold.2abbf852.woff2";